import { MealPlanAssignOption } from './utils';

const texts = {
  mealPlan: 'MEAL PLAN',
  allPlans: 'All plans',
  button: {
    [MealPlanAssignOption.NEW_MEAL_PLAN]: 'Assign New Meal Plan',
    [MealPlanAssignOption.USE_PREVIOUS_MEAL_PLAN]: 'Use Previous Meal Plan',
    [MealPlanAssignOption.AI_MEAL_PLAN]: 'AI Meal Plan',
  },
  filterBy: 'FILTER BY:',
  selectPlan: 'SELECT A PLAN:',
  name: 'NAME:',
  namePlaceholder: 'Meal plan name',
  note: 'NOTE:',
  notePlaceholder: 'Personalized meal plan note',
  macros: 'MACROS:',
  protein: '<strong>{percentage}%</strong> Protein',
  carbs: '<strong>{percentage}%</strong> Carbs',
  fat: '<strong>{percentage}%</strong> Fat',
  dietaryCompliance: 'DIETARY COMPLIANCE:',
  allergens: 'ALLERGENS:',
  ingredientExclusions: 'DISLIKED INGREDIENTS:',
  noAllergens: 'None',
  moreItems: '+{amount} More',
  updateDate: 'Updated: {date}',
  addRecipes: 'Add Recipes',
  updateMealTimes: 'Update Meal Times',
  loadingMealPlan: 'Please wait while we load the meal plan...',
  regeneratePlan: 'Regenerate Plan',
  generateAIMealPlan: 'Generate AI Meal Plan',
  generatingAIMealPlan: 'Generating AI Meal Plan...',
  generateAIMealPlanDescription: 'Use this to generate a personalized meal plan with the help of AI',
  aiMealPlanGenerationError: 'Error generating AI meal plan. Please try again later.',
  aiMealPlanGenerating: 'Generating meal plan... This can take several minutes. Please wait.',
  saveRecipe: 'Save Recipe',
  saveRecipeDescription: 'This recipe will be saved to your recipe library.',
  recipeName: 'Recipe Name',
  recipeNamePlaceholder: 'Enter recipe name',
  save: 'Save',
  cancel: 'Cancel',
  recipeSavedSuccessfully: 'Recipe saved successfully',
  recipeSaveFailed: 'Failed to save recipe: {error}',
};

export default texts;
